export const environment = {
  enableTourLines: false,
  isEnabled:true,
  production: false,
  apiEndPoint: 'https://amgmaa-nonprod.mercedes-benz.com/aca',
  proxyEndpoint:'https://proxy.int.stories.me/customerPortal', // URLs to change post proxy migration
  apikey: "dummy-api-key",
  encryptionKey: 'secret key 123',
  supported_language: ['en-GB', 'en', 'de', 'de-DE', 'fr-FR', 'es-ES', 'cs-CZ', 'ko-KR', 'it-IT'],
  featureFlagLink:'../../assets/json/amap/feature-flag-amap-int.json',
};